import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Site from './Site';
import './index.css';
//import TagManager from 'react-gtm-module';
//const tagManagerArgs = {
//  gtmId: 'G-YW7CJHDVTQ'
//}

//TagManager.initialize(tagManagerArgs)

ReactDOM.hydrate(
  <BrowserRouter>
    <React.StrictMode>
      <Site />
    </React.StrictMode>
  </BrowserRouter>,
  document.getElementById('root')
);